import _ from "lodash";
import moment from "moment";

export default {
  setToken(state, token) {
    state.token = token;
  },
  setLoginSuccess(state, status) {
    state.loginSuccess = status;
  },
  setLoginError(state, message) {
    state.loginError = message;
  },
  setRegisterSuccess(state, status) {
    state.registerSuccess = status;
  },
  setRegisterError(state, message) {
    state.registerError = message;
  },
  setDeviceCid(state, id) {
    state.deviceCid = id;
  },
  setGlobalError(state, error) {
    state.globalError = error;
  },
  setClientSuccess(state, status) {
    state.clientSuccess = status;
  },
  setClient(state, client) {
    const replace = !client || client.replace;
    if (replace) {
      state.globalError = (client || {}).globalError;
    }
    if (client) {
      delete client.replace;
      delete client.globalError;
    }
    if (replace || !state.client) {
      if (client) {
        client.actualDateLocal = moment().format();
      }
      state.client = client;
    } else {
      delete client.actualDateLocal;
      _.assign(state.client, client);
    }
    sessionStorage.setItem("client", JSON.stringify(state.client));
  },
  setUpdateError(state, error) {
    state.updateError = error;
  },
  setUpdateSuccess(state, status) {
    state.updateSuccess = status;
  },
  setPaymentUrl(state, url) {
    state.paymentUrl = url;
  },
  setPayError(state, error) {
    state.payError = error;
  },
  setPaySuccess(state, status) {
    state.paySuccess = status;
  },
  setPayStatusSuccess(state, status) {
    state.payStatusSuccess = status;
  },
  setPayStatusError(state, error) {
    state.payStatusError = error;
  },
  setPaySum(state, sum) {
    state.paySum = sum;
  },
  setReconciliationSuccess(state, status) {
    state.reconciliationSuccess = status;
  },
  setReconciliationError(state, error) {
    state.reconciliationError = error;
  },
  setDiscounts(state, discounts) {
    state.discounts = discounts;
  },
  setPayments(state, payments) {
    state.payments = payments;
  },
  setDiscountsSuccess(state, status) {
    state.discountsSuccess = status;
  },
  setDiscountsError(state, error) {
    state.discountsError = error;
  },
  setPaymentsSuccess(state, status) {
    state.paymentsSuccess = status;
  },
  setPaymentsError(state, error) {
    state.paymentsError = error;
  },
  setBalances(state, balances) {
    state.balances = balances;
  },
  setBalancesSuccess(state, status) {
    state.balancesSuccess = status;
  },
  setBalancesError(state, error) {
    state.balancesError = error;
  },
  setReports(state, reports) {
    state.reports = reports;
  },
  setReportsSuccess(state, status) {
    state.reportsSuccess = status;
  },
  setReportsError(state, error) {
    state.reportsError = error;
  },
  setReportSuccess(state, status) {
    state.reportSuccess = status;
  },
  setReportError(state, error) {
    state.reportError = error;
  },
  setGroupDiscounts(state, groups) {
    state.groupDiscounts = groups;
  },
  setInvoiceId(state, id) {
    state.invoiceId = id;
  },
  setInvoiceSuccess(state, status) {
    state.invoiceSuccess = status;
  },
  setInvoiceError(state, error) {
    state.invoiceError = error;
  },
  setLoading(state, status) {
    state.loading = status;
  },
  setQrId(state, qrId) {
    state.qrId = qrId;
  },
  setLoadingClientData(state, status) {
    state.isLoadingClientData = status;
  },
  setHistorySelectedMonth(state, month) {
    state.historySelectedMonth = month;
  },
  setHistorySelectedYear(state, year) {
    state.historySelectedYear = year;
  },
  setHistoryCurrentClname(state, clname) {
    state.historyCurrentClname = clname;
  },
  setFeedbackSuccess(state, status) {
    state.feedbackSuccess = status;
  },
  setFeedbackError(state, error) {
    state.feedbackError = error;
  },
  setLoadingFeedback(state, status) {
    state.isLoadingFeedback = status;
  },
};
